import * as _ from "lodash";
import { AnalyticsGroupCollection } from "../../../apps/analytics/collections/AnalyticsGroups";
import { ModifyAnalyticsGroupModal } from "../../../apps/analytics/views/modals/ModifyAnalyticsGroup";
import { ControlGroupCollection } from "../../../apps/controls/collections/ControlGroups";
import { ModifyControlGroupModal } from "../../../apps/controls/views/modals/ModifyControlGroupModal";
import { VMeterGroupCollection } from "../../../apps/vmeter/collections/VMeterGroups";
import { ModifyVMeterGroupModal } from "../../../apps/vmeter/views/modals/ModifyVMeterGroup";
import { LocationCollection } from "../../../apps/weather/collections/Locations";
import { ModifyLocationModal } from "../../../apps/weather/views/modals/ModifyLocationModal";
import { BaseInternalView, BaseInternalViewOptions } from "../../_BaseViews";

export interface AddToolsViewOptions extends BaseInternalViewOptions {
    controlGroupCollection: ControlGroupCollection;
    locationCollection: LocationCollection;
    vMeterGroupCollection: VMeterGroupCollection;
    analyticsGroupCollection: AnalyticsGroupCollection;
}

export class AddToolsView extends BaseInternalView {
    declare options: AddToolsViewOptions;
    private template = _.template(require("templates/tools/addTools.html"));
    private toolType: string;

    constructor(options: AddToolsViewOptions) {
        super(<any>_.extend({}, options));

        this.options.controlGroupCollection = new ControlGroupCollection();
        this.options.locationCollection = new LocationCollection();
        this.options.vMeterGroupCollection = new VMeterGroupCollection();
        this.options.analyticsGroupCollection = new AnalyticsGroupCollection();
    }

    render() {
        this.$el.html(this.template({
            permissionCollection: this.options.permissionCollection,
        }));

        switch (this.toolType) {
            case "control":
                const createControlView = new ModifyControlGroupModal(
                    _.extend({}, this.options, {
                        modelId: null,
                    }) as any
                );
                $(".modals").append(createControlView.render().el);
                createControlView.show();
                break;
            case "weather":
                $.when(this.options.locationCollection.fetch()).always(() => {
                    const createWeatherView = new ModifyLocationModal(
                        _.extend({}, this.options, {
                            locationId: null,
                            modelId: null,
                        }) as any
                    );
                    $(".modals").append(createWeatherView.render().el);
                    createWeatherView.show();
                });
                break;
            case "meter":
                const createMeterView = new ModifyVMeterGroupModal(
                    _.extend({}, this.options, {
                        modelId: null,
                    }) as any
                );
                $(".modals").append(createMeterView.render().el);
                createMeterView.show();
                break;
            case "analytic":
                const createAnalyticView = new ModifyAnalyticsGroupModal(
                    _.extend({}, this.options, {
                        analyticsTemplateCollection: null,
                        category: null,
                        itemId: null,
                        analyticsGroupId: null,
                    }) as any
                );
                $(".modals").append(createAnalyticView.render().el);
                createAnalyticView.show();
                break;
            default:
                break;
        }

        return this;
    }

    show(toolType) {
        // Get modal id from the router
        this.toolType = toolType;
        console.log("toolType", toolType);
        this.render();
    }

    remove() {
        // while (this.subViews.length) this.subViews.pop().remove();
        // But also do what the super view would normally do
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/tools/AddToolsView.ts